import { Injectable, signal } from '@angular/core';

export interface CursorPosition {
  x: number;
  y: number;
}

/**
 * Holds the synthetic cursor's target position + visibility as signals.
 *
 * The cursor element itself lives in the {@link GuideOverlayComponent} template
 * bound to these signals; the tween between positions is a CSS transition on
 * `transform`. Keeping the state here (not in raw DOM) makes it testable and
 * keeps Angular in control of rendering.
 */
@Injectable({ providedIn: 'root' })
export class GuideCursorService {
  readonly position = signal<CursorPosition>({ x: 0, y: 0 });
  readonly visible = signal(false);

  moveTo(x: number, y: number): void {
    this.position.set({ x, y });
    this.visible.set(true);
  }

  hide(): void {
    this.visible.set(false);
  }
}
